__turbopack_context__.v({
  "className": "poppins_2d09d693-module__xMHM9a__className",
});
